var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-alert',{attrs:{"variant":"primary","show":""}},[_c('div',{staticClass:"alert-body"},[_c('span',[_c('strong',[_vm._v(_vm._s(_vm.$t('swal.attention')))]),_vm._v(" "+_vm._s(_vm.$t('sites.parsing_alert')))])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }